import { Component, computed, input, output } from '@angular/core';
import { SEMANTIC_STYLES, SemanticType } from 'src/ui/types/semantic.type';

export type ModalType = SemanticType | 'none';

@Component({
  selector: 'app-modal',
  standalone: true,
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  visible = input(false);
  type = input<ModalType>('none');
  title = input('');
  message = input('');
  confirmText = input('Aceptar');
  cancelText = input('Cancelar');
  confirmDisabled = input(false);
  showCancel = input(false);
  showCloseIcon = input(false);
  closeOnBackdrop = input(true);

  confirm = output<void>();
  cancel = output<void>();

  protected readonly iconStyle = computed(() => {
    const type = this.type();
    return type === 'none' ? null : SEMANTIC_STYLES[type];
  });

  onBackdropDismiss(): void {
    if (!this.closeOnBackdrop()) return;
    this.cancel.emit();
  }
}
